import { useState } from 'react';

export default function useToggle(defaultChecked = false) {
  const [toggle, setToggle] = useState(defaultChecked);

  return {
    toggle,
    setToggle,
    onToggle: () => setToggle(!toggle),
    onClose: () => setToggle(false),
    onOpen: () => setToggle(true),
  };
}
